import { ref, getCurrentInstance } from 'vue';
import apiService from '@/services/api-comunicados';

/**
 * Composable para cargar y exponer la lista de países desde el API.
 *
 * @returns {Object} Estado reactivo y función de carga.
 */

export function useGetPaises() {
    const instance = getCurrentInstance();
    const toast = instance?.proxy.$toast;

    const paises = ref([]);
    const loadingPaises = ref(false);
    const error = ref(null);

    /**
     * Carga los países si aún no han sido obtenidos.
     * Muestra un toast en caso de error.
     *
     * @returns {Promise<void>}
     */

    const cargarPaises = async() => {
        if (paises.value.length > 0 && !error.value) return;

        loadingPaises.value = true;
        error.value = null;

        try {
            const response = await apiService.getPaises();
            paises.value = response.data
        } catch (err) {
            error.value = err;
            toast.error(err.message);
        } finally {
            loadingPaises.value = false;
        }
    };

    return {
        paises,
        loadingPaises,
        error,
        cargarPaises
    };
}
